import { PickedMeetingLocation } from '@chilipiper/api-type-def'

export const isPickedMeetingLocationValid = (pickedMeetingLocation?: PickedMeetingLocation) => {
  if (!pickedMeetingLocation) {
    return true
  }
  return (
    pickedMeetingLocation.type !== 'AskTheGuest' ||
    (pickedMeetingLocation.type === 'AskTheGuest' && !!pickedMeetingLocation.text)
  )
}
